import BoxFilePreview from './BoxFilePreview';
export default BoxFilePreview;
